import { FunctionComponent } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { resolveLegacyContactsTabTarget } from "../utils/resolveLegacyContactsTabTarget";
import { ContactsView } from "./ContactsView";

/**
 * Index element of /app/contacts: forwards legacy `?tab=` links to the routed
 * pages that replaced the tabs (PREC-3781) and renders the Contacts view for
 * everything else.
 */
export const ContactsIndexRoute: FunctionComponent = () => {
	const { search } = useLocation();
	const legacyTarget = resolveLegacyContactsTabTarget(search);

	if (legacyTarget) {
		return <Navigate replace to={legacyTarget} />;
	}

	return <ContactsView />;
};
